import React from "react";

import { HourMinutesSecondsMillis } from "~/tools/date-time/format/clock-time-format";
import { formatAbsoluteTime } from "~/tools/date-time/format/format-absolute-time";
import type { Time } from "~/tools/date-time/time";

export const DiffHeader = ({
	originalTimestamp,
	modifiedTimestamp,
}: {
	originalTimestamp: Time | number;
	modifiedTimestamp: Time | number;
}) => (
	<div className="flex flex-row rounded bg-grey-200 pr-8">
		<h2 className="mb-0 w-1/2 p-3 font-normal text-xs">
			Previous -{" "}
			{formatAbsoluteTime(originalTimestamp, {
				clockTimeFormat: HourMinutesSecondsMillis,
			}).toString()}
		</h2>

		<h2 className="mb-0 w-1/2 border-grey-400 border-l-px p-3 font-bold text-xs">
			Change -{" "}
			{formatAbsoluteTime(modifiedTimestamp, {
				clockTimeFormat: HourMinutesSecondsMillis,
			}).toString()}
		</h2>
	</div>
);
